<div [class]="containerClasses()">
    @if (label()) {
        <label [for]="inputId">
            {{ label() | translate }}
            @if (isRequired()) {
                <span class="text-danger" aria-label="required">*</span>
            }
            @if (labelTooltip()) {
                <i class="ti ti-info-circle-filled text-muted ti-sm" ngbTooltip="{{labelTooltip() | translate}}"></i>
            }
        </label>
    }

    <div [ngClass]="{'custom-input-group': hasIcon()}">
        @if (isLeftIcon()) {
            <span class="custom-input-group-text icon-left" (click)="onClick.emit()">
                <i class="ti ti-{{groupIcon()}}" aria-hidden="true"></i>
            </span>
        }
        <input #inputElement
               [id]="inputId"
               type="text"
               [class]="inputClasses()"
               [placeholder]="placeholder() | translate"
               [readonly]="readonly()"
               [autocomplete]="autocomplete()"
               [disabled]="isDisabled()"
               [(ngModel)]="currentValue"
               (input)="handleInput($event)"
               (focus)="onFocus()"
               (blur)="onBlur()"
               [class.ng-invalid]="isInvalid"
               [class.ng-touched]="isTouched"
               [class.ng-dirty]="isDirty"
               mask="{{mask()}}"
               [thousandSeparator]="thousandSeparator()"
               [separatorLimit]="separatorLimit()"
               [prefix]="prefix()"
               [dropSpecialCharacters]="false">

        @if (isRightIcon()) {
            <span class="custom-input-group-text icon-right" (click)="onClick.emit()">
                <i class="ti ti-{{groupIcon()}}" aria-hidden="true"></i>
            </span>
        }
    </div>

    @if (showErrorDescription()) {
        @if (ngControl?.control) {
            <app-control-error
                    [control]="getControl()"
                    [customErrors]="customErrors()">
            </app-control-error>
        }
    }

    @if (hint()) {
        <div class="form-text" [id]="inputId + '_hint'">
            {{ hint() | translate }}
        </div>
    }
</div>

